module.exports = __webpack_public_path__ + "static/media/clear.63c335dc.svg";